import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Garden tree ~3 m tall: a tapered bark trunk and three faceted leaf clumps.
// The canopy stays within ~1.4 m diameter so it fits a 1x1 garden tile.
const BARK = "#6b4a2a";
const LEAF = "#5f8f4e";
const LEAF_DARK = "#4e7a3e";

export const gardenTree = defineModel({
  id: "garden-tree",
  batchId: "modern",
  name: "Garden tree",
  tags: ["modern", "outdoor", "garden", "tree", "plant"],
  summary: "A garden tree about three metres tall with a compact canopy.",
  description:
    "A mature garden tree of the Modern Living kit: ~3 m tall, a tapered " +
    "bark trunk with three faceted leaf clumps; the canopy stays within " +
    "~1.4 m diameter so it sits on a single garden tile.",
  tiles: { w: 1, h: 1 },
  footprint: 1.6,
  parts(): Part[] {
    return [
      {
        geometry: new THREE.CylinderGeometry(0.09, 0.15, 1.5, 7),
        color: BARK,
        position: [0, 0.75, 0],
      },
      { geometry: new THREE.IcosahedronGeometry(0.62, 0), color: LEAF, position: [0, 2.15, 0] },
      {
        geometry: new THREE.IcosahedronGeometry(0.42, 0),
        color: LEAF_DARK,
        position: [0.26, 2.5, 0.14],
      },
      {
        geometry: new THREE.IcosahedronGeometry(0.36, 0),
        color: LEAF_DARK,
        position: [-0.28, 2.35, -0.18],
      },
    ];
  },
  animations: [],
});
